export const ERROR_MSGS = {
  REFUNDED: 'Envelope has been refunded',
  ALREADY_REDEEMED: 'Envelope was already redeemed.',
};
export const TICKET_BG_COLOR_HEX = '#ffffff';
export const BARCODE_BORDER_COLOR_HEX = '#EBEBEBFF';
